export default __webpack_public_path__ + "static/media/toastError.51bedd10.svg";